import { invalid } from "moment";

var accountDoesNotExist = "ACCOUNT_DOESNOT_EXIST";
var invalidJob="INVALID_JOB";
var invalidReviewReq="INVALID_REVIEW_REQ";
var jobAppliedPreviously="JOB_APPLIED_PREVIOUSLY";
var jobIsNotActive="JOB_IS_NOT_ACTIVE";
export const GenericCodes = {
    accountDoesNotExist:accountDoesNotExist,
    invalidJob: invalidJob,
    invalidReviewReq:invalidReviewReq,
    jobAppliedPreviously:jobAppliedPreviously,
    jobIsNotActive:jobIsNotActive,
}